<template>
  <div class="row p-md-5 mx-md-3 mb-5">
    <div class="col-12">
      <div class="row justify-content-center">
        <div class="col-md-3 text-center">
          <div class="row">
            <div class="col-12 mt-md-3 text-center">
              <h3 class="mt-md-5 mt-3">Cuestionario</h3>
            </div>
            <div class="col-12 mb-md-3 text-center">
              <h2 class="mb-md-5 mb-3">Catell</h2>
            </div>
          </div>
          <div class="row d-none d-md-block">
            <div class="col-12 mt-3 text-center">
              <button class="btn btn-lg btn-primary" v-on:click="Iniciar_Examen">Iniciar <i class="fas fa-arrow-circle-right"></i></button>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <ul class="nav nav-tabs mx-3" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Instrucciones</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="home2-tab" data-toggle="tab" href="#home2" role="tab" aria-controls="home2" aria-selected="true">Ejemplo</a>
            </li>
          </ul>
          <div class="tab-content mx-2" id="myTabContent">
            <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
              <div class="row mt-3">
                <div class="col-12 text-center">
                  <b>Instrucciones</b>
                </div>
                <div class="col-12 mt-3">
                  A continuación aparecerá una serie de preguntas con tres posibles respuestas de Sí, No y Ninguna de las dos, de las cuales deberá de elegir solo una de ellas en cada pregunta.
                </div>
                <div class="col-12 text-center mt-3">
                  <b>Al contestar tenga en cuenta lo siguiente.</b>
                </div>
                <div class="col-12 mt-3">
                  Leer cuidadosamente cada pregunta y contestar lo más rápidamente posible.
                </div>
                <div class="col-12 mt-3">
                  No pensar demasiado las preguntas ni emplee mucho tiempo en decidirse. Generalmente se contestan cinco o seis por minuto, y se tarda poco más de media hora para completar todo el cuestionario.
                </div>
                <div class="col-12 mt-3">
                  Conteste sinceramente. No señale sus respuestas pensando en lo que "es bueno" o "lo que interesa" para impresionar al examinador.
                </div>
              </div>
            </div>
            <div class="tab-pane fade show" id="home2" role="tabpanel" aria-labelledby="home2-tab">
              <div class="row mt-3">
                <div class="col-12">
                  Tal vez algunas preguntas le parezcan muy personales; no se preocupe y recuerde que las respuestas se guardan como información confidencial; por otra parte, al obtener los resultados no se consideran las respuestas una a una, sino globalmente.
                </div>
                <div class="col-12 mt-3">
                  <b>Seleccionar respuesta:</b>
                </div>
                <div class="col-12 mt-3">
                  1. Posicione la flecha del mouse sobre el texto de la respuesta deseada.
                </div>
                <div class="col-12 mt-3">
                  2. Presione el botón derecho del mouse para marcar la respuesta.
                </div>
                <div class="col-12 mt-3">
                  <b>Cancelar respuesta:</b>
                </div>
                <div class="col-12 mt-3">
                  1. Posicione la flecha del mouse en la respuesta a cancelar.
                </div>
                <div class="col-12 mt-3">
                  2. Presione el botón izquierdo del mouse para quitar la marca a la respuesta.
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col" class="text-center">Pregunta</th>
                        <th scope="col" class="text-center">Respuesta</th>
                        <th scope="col" class="text-center"></th>
                      </tr>
                    </thead>
                    <tbody v-for="pregunta of ejemplo.preguntas" v-if="pregunta.active">
                      <tr>
                        <td rowspan="3">{{pregunta.numero}}</td>
                        <td rowspan="3">{{pregunta.nompregunta}}</td>
                        <td 
                          v-on:click="Seleccionar_Respuesta(pregunta.numero, 1)" 
                          class="select_respuesta">
                            Si
                        </td>
                        <td
                          v-on:click="Seleccionar_Respuesta(pregunta.numero, 1)" 
                          class="text-center select_respuesta">
                          <i 
                            v-if="pregunta.respuesta===1" class="fas fa-check" />
                        </td>
                      </tr>
                      <tr>
                        <td 
                          v-on:click="Seleccionar_Respuesta(pregunta.numero, 2)" 
                          class="select_respuesta">
                            No
                        </td>
                        <td 
                          v-on:click="Seleccionar_Respuesta(pregunta.numero, 2)" 
                          class="text-center select_respuesta">
                          <i 
                            v-if="pregunta.respuesta===2" class="fas fa-check" />
                        </td>
                      </tr>
                      <tr>
                        <td 
                          v-on:click="Seleccionar_Respuesta(pregunta.numero, 3)" 
                          class="select_respuesta">
                            Ninguna de las dos
                        </td>
                        <td 
                          v-on:click="Seleccionar_Respuesta(pregunta.numero, 3)" 
                          class="text-center select_respuesta">
                          <i 
                            v-if="pregunta.respuesta===3" class="fas fa-check" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 mt-5 text-center d-block d-md-none">
          <button class="btn btn-lg btn-primary" v-on:click="Iniciar_Examen">Iniciar <i class="fas fa-arrow-circle-right"></i></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading:'d-none',
      result:'',
      ejemplo:{
        preguntas:[
          {
            numero:1,
            active:true,
            nompregunta: 'Me gusta el trabajo del laboratorio',
            respuesta: null
          },
        ]
      }
    }
  },
  methods:{
    Seleccionar_Respuesta(numero_pregunta,respuesta){
      const pregunta = this.ejemplo.preguntas.filter(function (pregunta) {
            return pregunta.active == true;
        })

        if (pregunta[0].respuesta === respuesta) pregunta[0].respuesta = ''
        else pregunta[0].respuesta = respuesta
    },
    Iniciar_Examen(){
      this.$router.push({name:'catell_preguntas'});
    },
    Cargando(){
      this.loading='';
      this.result='d-none';
    },
    Listo(){
      this.loading='d-none';
      this.result='';
    }
  }
};
</script>

<style>
.select_respuesta{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Examenes/Catell/Instrucciones.vue